import { render, staticRenderFns } from "./BusquedaNoRealizada.vue?vue&type=template&id=1c59c5c5"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\capredena\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1c59c5c5')) {
      api.createRecord('1c59c5c5', component.options)
    } else {
      api.reload('1c59c5c5', component.options)
    }
    module.hot.accept("./BusquedaNoRealizada.vue?vue&type=template&id=1c59c5c5", function () {
      api.rerender('1c59c5c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/DashboardReportNMV/components/BusquedaNoRealizada.vue"
export default component.exports